<template>
  <form @submit.prevent="submit">
    <va-input
      v-model="form.title"
      label="Название"
      class="mb-3"
      :error="!!errors.title"
      :error-messages="errors.title"
    />
    <div class="mb-3">
      <label class="va-input__label">Дата начала</label>
      <input
        v-model="form.date_from"
        type="date"
        class="form-control"
        required
      />
      <span v-if="errors.date_from" class="error-message">{{
        errors.date_from
      }}</span>
    </div>
    <div class="mb-3">
      <label class="va-input__label">Дата окончания</label>
      <input v-model="form.date_to" type="date" class="form-control" required />
      <span v-if="errors.date_to" class="error-message">{{
        errors.date_to
      }}</span>
    </div>
    <div class="mb-3">
      <label class="va-input__label">Тип доставки (пусто = все)</label>
      <select v-model="form.delivery_type_id" class="form-control">
        <option value="">Все типы</option>
        <option
          v-for="opt in deliveryTypeSelectOptions"
          :key="opt.value"
          :value="opt.value"
        >
          {{ opt.text }}
        </option>
      </select>
    </div>
    <va-input
      v-model.number="form.min_cart_sum"
      type="number"
      min="0"
      label="Минимальная сумма заказа (пусто = не учитывается)"
      class="mb-3"
      placeholder=""
    />
    <va-checkbox
      v-model="form.make_free"
      label="Сделать доставку бесплатной"
      class="mb-3"
    />
    <va-input
      v-if="!form.make_free"
      v-model.number="form.price_override"
      type="number"
      min="0"
      label="Цена по акции (пусто = без изменений)"
      class="mb-3"
      placeholder=""
    />
    <va-input
      v-model.number="form.priority"
      type="number"
      min="0"
      label="Приоритет (чем выше — тем приоритетнее)"
      class="mb-3"
    />
    <va-checkbox v-model="form.is_active" label="Активна" class="mb-4" />
    <div class="d-flex gap-2">
      <va-button type="submit" color="primary">Сохранить</va-button>
      <va-button type="button" @click="$emit('cancel')">Отмена</va-button>
    </div>
  </form>
</template>

<script>
export default {
  name: "DeliveryPromotionForm",
  props: {
    initial: { type: Object, default: null },
    deliveryTypes: { type: Array, default: () => [] },
  },
  data() {
    return {
      form: {
        title: "",
        date_from: "",
        date_to: "",
        delivery_type_id: "",
        min_cart_sum: null,
        make_free: false,
        price_override: null,
        priority: 0,
        is_active: true,
      },
      errors: {},
    };
  },
  computed: {
    deliveryTypeSelectOptions() {
      return (this.deliveryTypes || [])
        .filter((o) => o.value != null && o.value !== "")
        .map((o) => ({
          value: Number(o.value),
          text: o.text || String(o.value),
        }));
    },
  },
  watch: {
    initial: {
      immediate: true,
      handler(val) {
        if (val) {
          this.form = {
            title: val.title || "",
            date_from: String(val.date_from || "").substring(0, 10),
            date_to: String(val.date_to || "").substring(0, 10),
            delivery_type_id:
              val.delivery_type_id != null && val.delivery_type_id !== ""
                ? Number(val.delivery_type_id)
                : "",
            min_cart_sum:
              val.min_cart_sum != null ? Number(val.min_cart_sum) : null,
            make_free: !!val.make_free,
            price_override:
              val.price_override != null ? Number(val.price_override) : null,
            priority: Number(val.priority) || 0,
            is_active: !!val.is_active,
          };
        } else {
          this.form = {
            title: "",
            date_from: "",
            date_to: "",
            delivery_type_id: "",
            min_cart_sum: null,
            make_free: false,
            price_override: null,
            priority: 0,
            is_active: true,
          };
        }
        this.errors = {};
      },
    },
  },
  methods: {
    validate() {
      this.errors = {};
      if (!this.form.title || !this.form.title.trim())
        this.errors.title = "Обязательное поле";
      if (!this.form.date_from) this.errors.date_from = "Обязательное поле";
      if (!this.form.date_to) this.errors.date_to = "Обязательное поле";
      if (
        this.form.date_from &&
        this.form.date_to &&
        this.form.date_from > this.form.date_to
      ) {
        this.errors.date_to =
          "Дата окончания должна быть не раньше даты начала";
      }
      if (this.form.priority < 0)
        this.errors.priority = "Число не может быть отрицательным";
      return Object.keys(this.errors).length === 0;
    },
    submit() {
      if (!this.validate()) return;
      this.$emit("submit", {
        title: this.form.title.trim(),
        date_from: this.form.date_from,
        date_to: this.form.date_to,
        delivery_type_id:
          this.form.delivery_type_id === "" ||
          this.form.delivery_type_id == null
            ? null
            : Number(this.form.delivery_type_id),
        min_cart_sum:
          this.form.min_cart_sum === "" || this.form.min_cart_sum == null
            ? null
            : Number(this.form.min_cart_sum),
        make_free: this.form.make_free,
        price_override:
          this.form.make_free ||
          this.form.price_override === "" ||
          this.form.price_override == null
            ? null
            : Number(this.form.price_override),
        priority: Number(this.form.priority) || 0,
        is_active: this.form.is_active,
      });
    },
  },
};
</script>

<style scoped>
.form-control {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.error-message {
  color: #e34a4a;
  font-size: 0.875rem;
}
</style>
